import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-skills-grid',
  templateUrl: './skills-grid.component.html',
  styleUrls: ['./skills-grid.component.scss']
})
export class SkillsGridComponent implements OnInit, AfterViewInit {

  @Input() source;
  skills;
  currentSkill;

  constructor(private router: Router,
              public mainService: MainService) {
    this.skills = [
      {
        id: 'ready',
        title: 'skills.ready.card.description',
        items: [
          {
            icon: 'assets/icons/software_develop.svg',
            infosIcon: 'assets/icons/infos/software_develop.svg',
            title: 'skills.ready.detail.development.title',
            description: 'skills.ready.detail.development.description'
          },
          {
            icon: 'assets/icons/software_factory.svg',
            infosIcon: 'assets/icons/infos/software_factory.svg',
            title: 'skills.ready.detail.factory.title',
            description: 'skills.ready.detail.factory.description'
          },
          {
            icon: 'assets/icons/project_methodology.svg',
            infosIcon: 'assets/icons/infos/project_methodology.svg',
            title: 'skills.ready.detail.agile.title',
            description: 'skills.ready.detail.agile.description'
          },
          {
            icon: 'assets/icons/factory_deployment.svg',
            infosIcon: 'assets/icons/infos/factory_deployment.svg',
            title: 'skills.ready.detail.deployment.title',
            description: 'skills.ready.detail.deployment.description'
          },
          {
            icon: 'assets/icons/project_coaching.svg',
            infosIcon: 'assets/icons/infos/project_coaching.svg',
            title: 'skills.ready.detail.coaching.title',
            description: 'skills.ready.detail.coaching.description'
          }
        ]
      },
      {
        id: 'deploying',
        title: 'skills.deploying.card.description',
        items: [
          {
            icon: 'assets/icons/wifi.svg',
            infosIcon: 'assets/icons/infos/wifi.svg',
            title: 'skills.deploying.detail.wifi.title',
            description: 'skills.deploying.detail.wifi.description'
          },
          {
            icon: 'assets/icons/renting_services.svg',
            infosIcon: 'assets/icons/infos/renting_services.svg',
            title: 'skills.deploying.detail.renting.title',
            description: 'skills.deploying.detail.renting.description'
          },
          {
            icon: 'assets/icons/ready.svg',
            infosIcon: 'assets/icons/infos/ready.svg',
            title: 'skills.deploying.detail.ready.title',
            description: 'skills.deploying.detail.ready.description'
          },
          {
            icon: 'assets/icons/maintenance_repair.svg',
            infosIcon: 'assets/icons/infos/maintenance_repair.svg',
            title: 'skills.deploying.detail.maintenance.title',
            description: 'skills.deploying.detail.maintenance.description'
          },
          {
            icon: 'assets/icons/help_desk.svg',
            infosIcon: 'assets/icons/infos/help_desk.svg',
            title: 'skills.deploying.detail.help.title',
            description: 'skills.deploying.detail.help.description'
          },
        ]
      },
      {
        id: 'cloudbase',
        title: 'skills.cloud.card.description',
        items: [
          {
            icon: 'assets/icons/on_demand_performances.svg',
            infosIcon: 'assets/icons/infos/on_demand_performances.svg',
            title: 'skills.cloud.detail.ondemand.title',
            description: 'skills.cloud.detail.ondemand.description'
          },
          {
            icon: 'assets/icons/reliability.svg',
            infosIcon: 'assets/icons/infos/reliability.svg',
            title: 'skills.cloud.detail.reliability.title',
            description: 'skills.cloud.detail.reliability.description'
          },
          {
            icon: 'assets/icons/speed_up.svg',
            infosIcon: 'assets/icons/infos/speed_up.svg',
            title: 'skills.cloud.detail.speed.title',
            description: 'skills.cloud.detail.speed.description'
          },
          {
            icon: 'assets/icons/proximity.svg',
            infosIcon: 'assets/icons/infos/proximity.svg',
            title: 'skills.cloud.detail.proximity.title',
            description: 'skills.cloud.detail.proximity.description'
          }
        ]
      }];
  }

  ngOnInit() {
    // this.currentSkill = this.skills[0];
  }
  ngAfterViewInit() {
    this.currentSkill = this.skills[0];
  }

  public goto(skillId) {
    this.skills.forEach(
      (item) => {
        if (item.id === skillId) {
          this.currentSkill = item;
        }
      }
    );
  }
}
